import { FC, useState } from "react";
import "./SettingsScreen.css";
import backIcon from "../../assets/images/back-icon.svg";
import { useNavigate } from "react-router-dom";
import ProfileNonExpandableSection from "screens/Profile Screen/Views/ProfileNonExpandableSection";
import ROUTE_PATHS from "utils/routePaths";
import { WEB_LINK } from "utils/strings";
import LogoutDialog from "components/elements/LogoutDialog";
import { useLogout } from "services/LogoutProvider";

const SettingsScreen: FC = () => {
  const navigate = useNavigate();
  const [showLogoutDialog, setShowLogoutDialog] = useState<boolean>(false);
  const { handleLogout } = useLogout();

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="wms-mobile-container">
      <div className="settings-screen-container">
        <div className="settings-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="title">Settings</div>
        </div>
        <ProfileNonExpandableSection
          title="Terms &"
          subTitle="Conditions"
          onClick={() => {
            navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
              state: {
                anyData: {
                  title: "Terms & Conditions",
                  url: WEB_LINK.TERM_CONDITION,
                },
              },
            });
          }}
        />
        <ProfileNonExpandableSection
          title="Cancellation,"
          subTitle="Refund & Wallet Policy"
          onClick={() => {
            navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
              state: {
                anyData: {
                  title: "Cancellation, Refund & Wallet Policy",
                  url: WEB_LINK.PRIVACY_POLICY,
                },
              },
            });
          }}
        />
        <ProfileNonExpandableSection
          title="Logout"
          subTitle=""
          onClick={() => setShowLogoutDialog(true)}
        />
      </div>
      <LogoutDialog
        open={showLogoutDialog}
        onClose={() => setShowLogoutDialog(false)}
        onYes={() => handleLogout()}
      />
    </div>
  );
};

export default SettingsScreen;
